import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';
import { isNil } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ValidarAuthService implements Resolve<boolean> {

  constructor(private storage: StorageService, private ntf: ToastService) { }

  resolve(): Promise<boolean> {
    const usuario = this.storage.usuario
    const token = this.storage.token
    if (isNil(usuario) || isNil(token) || isNil(token.logueado)) {
      this.ntf.info('Usuario no ha iniciado sesión. Inicie sesión.');
      return Promise.reject(false);
    }

    return Promise.resolve(true);
  }
}
